module.exports = __webpack_public_path__ + "videos/multitouch.aa7d6ec.mp4";